// Design Ref: §3.1 / Plan FR-08 — refresh 단일 실행 + 대기 큐를 Promise 싱글톤으로 구현
// 순수 모듈: SvelteKit 의존성 없음, 단위 테스트 용이
//
// "fetch once, broadcast to all waiters" — 동시에 N건이 호출돼도 refreshFn은 1번만 실행되고
// 모든 호출자는 같은 결과(boolean)를 받는다. 결과 resolve 후 inFlight를 해제해 다음 사이클이
// 새 fetch를 시작하도록 한다.

export function createRefreshQueue(refreshFn) {
	let inFlight = null;

	return async function refresh() {
		if (inFlight) return inFlight;
		inFlight = (async () => {
			try {
				return await refreshFn();
			} catch {
				// refreshFn 내부에서 throw돼도 hang 없이 false로 통일
				return false;
			}
		})();
		try {
			return await inFlight;
		} finally {
			// 모든 await 완료 후 해제 (다음 cycle은 새 fetch)
			inFlight = null;
		}
	};
}
